import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  FinancingFlowMonitorData,
  FinancingFlowMonitorDrillDown,
  FinancingFlowMonitorFilters,
} from '../models/financing-flow-monitor.model';
import { FinancingFlowMonitorService } from '../tokens/financing-flow-monitor.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-backed Flow Monitor: Loan/Factoring service.
 *
 * Calls:
 *   GET /services/embedded/api/flow-monitor/loan/applications
 *   GET /services/embedded/api/flow-monitor/loan/{id}/drill-down
 * Authenticated via authInterceptor (signed-in master-admin bearer token).
 * REST-only per Rule 07/10. No mock fallback.
 *
 * Authority: ROLE_MASTER_ADMIN (enforced server-side; roleGuard in the portal).
 */
@Injectable()
export class FinancingFlowMonitorRestService implements FinancingFlowMonitorService {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/flow-monitor/loan`;

  getApplications(filters?: FinancingFlowMonitorFilters): Observable<FinancingFlowMonitorData> {
    let params = new HttpParams();
    if (filters?.product) params = params.set('product', filters.product);
    if (filters?.stage)   params = params.set('stage',   filters.stage);
    if (filters?.status)  params = params.set('status',  filters.status);
    return this.http.get<FinancingFlowMonitorData>(`${this.base}/applications`, { params });
  }

  getDrillDown(financingRequestId: number): Observable<FinancingFlowMonitorDrillDown> {
    return this.http.get<FinancingFlowMonitorDrillDown>(`${this.base}/${financingRequestId}/drill-down`);
  }

  downloadDocument(financingRequestId: number, documentId: number): Observable<Blob> {
    return this.http.get(
      `${this.base}/${financingRequestId}/documents/${documentId}/content`,
      { responseType: 'blob' },
    );
  }
}
